import { stringify } from 'query-string';
import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import type { MentionDescription } from '@atlaskit/mention';
import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { AbstractMentionProvider } from '../abstract-mention-provider/index.tsx';

export class ProjectMentionProvider extends AbstractMentionProvider {
	constructor(projectKey: ProjectKey, projectType?: ProjectType | null) {
		super(projectType);
		this.projectKey = projectKey;
	}

	getQueryString = (query?: string) =>
		stringify({
			query,
			projectKey: this.projectKey,
			maxResults: 10,
		});

	getUrl = (queryString: string) => `/rest/api/2/user/viewissue/search?${queryString}`;

	shouldHighlightMention = (mention: MentionDescription) => mention.id === this.projectKey;

	projectKey: string;
}
